import axios from 'axios';
import {api} from '../../../modules/Inspection/constants/api';
import {errors as E} from 'common/constants/errors';
import {actions as A} from 'modules/Inspection/constants/actions';

export const getStreets = cityID => dispatch => {
  dispatch({
    type: A.GET_STREETS,
  });

  return axios.post(api.GET_STREETS, {cityID})
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      dispatch({
        type: A.GET_STREETS_SUCCESS,
        payload: transformStreets(body.streets),
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_STREETS_FAILURE,
        payload: err.message
      })
    });
};

const transformStreets = streets => streets.map(street => {
  const {streetID, streetName} = street;
  return {label: streetName, value: streetID};
});
